import { Component, effect, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Toast } from 'primeng/toast';

import { TranslateService } from '../../core/i18n';
import { EstablishmentStore } from '../../features/establishment/store/establishment.store';
import { HeaderComponent } from '../header/header.component';
import { ImpersonationBannerComponent } from '../impersonation-banner/impersonation-banner.component';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { SidebarStore } from '../sidebar.store';

/** Routes that require admin or owner role */
const ADMIN_ONLY_ROUTES = ['/transactions', '/pos', '/end-report'];

@Component({
  selector: 'app-shell',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, ImpersonationBannerComponent, SidebarComponent, Toast],
  templateUrl: './app-shell.component.html',
  styles: `
    :host {
      display: block;
      min-height: 100vh;
    }
  `,
})
export class AppShellComponent {
  private readonly router = inject(Router);
  private readonly messageService = inject(MessageService);
  private readonly translateService = inject(TranslateService);
  private readonly establishmentStore = inject(EstablishmentStore);

  protected sidebarStore = inject(SidebarStore);

  constructor() {
    // Watch for establishment changes and redirect if user loses access to current page
    effect(() => {
      const currentEstablishment = this.establishmentStore.currentEstablishment();
      const canAccessAdminRoutes = this.establishmentStore.canAccessTransactions();
      const currentUrl = this.router.url;

      // Check if current route requires admin access
      const isOnAdminRoute = ADMIN_ONLY_ROUTES.some((route) => currentUrl.startsWith(route));

      // If on admin route but no longer has access, redirect to dashboard
      if (currentEstablishment && isOnAdminRoute && !canAccessAdminRoutes) {
        this.messageService.add({
          severity: 'warn',
          summary: this.translateService.get('common.warning'),
          detail: this.translateService.get('auth.noPermission'),
          life: 5000,
        });
        void this.router.navigate(['/dashboard']);
      }
    });
  }
}
